import React from 'react';
import styled from "styled-components";
import { LinkRef, Paragraph } from "../styles";

import profileImage from '../styles/img/liv.png';

const AboutContainer = styled.section`
  align: center;
  padding-bottom: 90px;
`;

const LinkContainer = styled.div`
  text-align: center;
  margin-top: 20px;
`;

const Profile = styled.img`
  width: 58vw;
  height: auto;
  display: inline;
  min-width: 200px;
  float: left;
  margin: 0 40px 1.4vw 0;
  border-radius: 4px;
`;

function About() {
  return (
    <AboutContainer>
      {/*<Profile src={profileImage} alt="Liv" className="profile" />*/}
      Livia Murray
    </AboutContainer>
  );
}

export default About;
